import { render, staticRenderFns } from "./TableServices.vue?vue&type=template&id=4bf4b70c&scoped=true"
import script from "./TableServices.vue?vue&type=script&lang=js"
export * from "./TableServices.vue?vue&type=script&lang=js"
import style0 from "./TableServices.vue?vue&type=style&index=0&id=4bf4b70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf4b70c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VDataFooter,VDataTable,VIcon,VTextField})
